import {
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextField
} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import {SmoothActionBar} from "../../../../misc/SmoothActionBar";
import React, {useState} from "react";
import {useReloader} from "./ReloadContext";
import {useAsyncAction} from "nate-react-api-helpers";
import {useSyncedRef} from "../../../../misc/SyncedRef";
import {useHwAPI} from "./HardwareGeneric";
import {EditHardwareGroupWithContent} from "./HwEditingContextProvider";
import {HardwareGroupUpsert} from "../../../../api/QuoteHardware";

export function RenameHardwareGroup(props: {
    value: EditHardwareGroupWithContent;
    onClose(): void;
}) {
    const [value, setValue] = useState<string>(props.value.name || "");
    const reloadRef = useReloader();
    const onCloseRef = useSyncedRef(props.onClose);
    const hapi = useHwAPI();

    const update = useAsyncAction(async (input: HardwareGroupUpsert) => {
        await hapi.upsert(input)
        reloadRef.current();
        onCloseRef.current();
    }, [hapi]);

    const submit = () => {
        update.callback({
            value: Object.assign({}, props.value, {name: value})
        })
    };

    return (
        <Dialog2 open onClose={props.onClose} onEnterPress={submit}>
            <DialogTitle>
                Rename Hardware Heading
            </DialogTitle>
            <DialogContent>
                <DialogContentText></DialogContentText>
                <TextField value={value} onChange={e => setValue(e.target.value)} />
            </DialogContent>
            <SmoothActionBar
                loading={update.loading}
                error={update.error}
                onCancel={props.onClose}
                onSubmit={submit}
            />
        </Dialog2>
    )
}